import { api } from "@/lib/api-client"

// =============================================================================
// Slide Sense module config API (backend: routes/admin/slide_sense_config.py)
// =============================================================================

export interface SlideSensePresenterModes {
  presentation: boolean
  presenter_view: boolean
}

export interface SlideSenseConfigResponse {
  presenter_modes: SlideSensePresenterModes
}

export async function getSlideSenseConfig(): Promise<SlideSenseConfigResponse> {
  const response = await api.get("/admin/slide-sense/config")
  return response.data || response
}

export async function updateSlideSenseConfig(
  presenterModes: SlideSensePresenterModes
): Promise<SlideSenseConfigResponse> {
  const response = await api.put("/admin/slide-sense/config", {
    presenter_modes: presenterModes,
  })
  return response.data || response
}
